import { SelectControl } from '../controls/select-control.model';
import { UiColumn } from '../ui-column';

export class OrganizationSelect extends SelectControl {

  constructor(id: string, label: string, value: any, onlyShowThisColumn?: string);
  constructor(id: string, label: string, values: Array<any>, onlyShowThisColumn?: string);
  constructor(...arr: any[]) {
    var id = arr[0];
    var label = arr[1];
    var values = arr[2];
    var singleColumnMember = arr[3];
    var data: Array<any> = [];

    var isArray = values instanceof Array;

    if (isArray) {
      data = values;
    } else {
      data.push(values);
    }

    super(id, label, data, isArray, singleColumnMember);

    this.apiController = "Organization";
    this.displayMember = "name";
    this.valueMember = "id";
    this.forceDataLoadOnOpen = true;
    this.columns = [
      //new UiColumn("ID", "ID", 200),
      new UiColumn("name", "Name", 150),
    ];
  }

}
